var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.026 12.525a6.4 6.4 0 11-9.052-9.051 6.4 6.4 0 019.052 9.051zm-6.36-5.96a.8.8 0 11-1.132-1.13.8.8 0 011.132 1.13zm4.8 0a.8.8 0 10-1.132-1.13.8.8 0 001.132 1.13zM5.93 11.677a.8.8 0 01-.26-1.305 4 4 0 015.658 0 .8.8 0 01-1.132 1.132 2.4 2.4 0 00-3.394 0 .8.8 0 01-.872.173zM4.5 9.6a.8.8 0 00.8-.8c0-.442-.8-1.6-.8-1.6s-.8 1.158-.8 1.6a.8.8 0 00.8.8z",
    fill: "#5F93F3"
  })));
}
export default SvgSad;